import {
	ConstrainDimensionsSelector,
	IsInPresentationMode,
} from "../../state/ui";

import { NavigationType } from "../../state/navigation";
import type { NavigationTypeType } from "@quickpoint.me/shared";
import { PageSizeAtom } from "../../state/page";
import styled from "styled-components";
import { useRecoilValue } from "recoil";

const StyledFilterBackGround = styled.div<{
	url?: string;
	$constrainDimensions: boolean;
	$isInPresentationMode: boolean;
	$height: number;
	$width: number;
	$navigationType: NavigationTypeType;
}>`
  min-width: ${(props) => (props.$constrainDimensions ? `${props.$width}px` : "100vw")};
  min-width: ${(props) => (props.$constrainDimensions ? `${props.$width}px` : "100svw")};
   min-height: ${(props) => {
			if (props.$isInPresentationMode) return "100vh";
			if (props.$constrainDimensions) return `${props.$height}px`;
			return "100vh";
		}};
  position: ${(props) => (props.$constrainDimensions ? "absolute" : "fixed")};
  top: 0;
  background-color: ${(props) => {
		return props.theme.background ?? "unset";
	}};
  overflow:hidden;
`;

/**
 * The filter backdrop sits at the bottom. The backdrop: tag creates an element that sits on top.
 * @returns ReactElement<ElementProps>
 */
function FilterBackGround() {
	const constrainDimensions = useRecoilValue(ConstrainDimensionsSelector);
	const pageSize = useRecoilValue(PageSizeAtom);
	const navigationType = useRecoilValue(NavigationType);
	const isInPresentationMode = useRecoilValue(IsInPresentationMode);

	return (
		<StyledFilterBackGround
			data-testid="filter-background"
			role="none"
			$constrainDimensions={constrainDimensions}
			$isInPresentationMode={isInPresentationMode}
			$height={pageSize.height}
			$navigationType={navigationType}
			$width={pageSize.width}
			className="filter-background"
		/>
	);
}

export default FilterBackGround;
